module.exports = __webpack_public_path__ + "static/media/t1.5b4df46c.png";